'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DownloadIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DownloadIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Download-3--Streamline-Cyber"
        height="24"
        width="24"
      >
        <desc>Download 3 Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke={sx ? sx.color : "#092f63"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M22.5 18.5v5H0.5v-5"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx ? sx.color : "#092f63"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M11.5 17.5v-16"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx ? sx.color : "#092f63"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="m16 13 -4.5 4.5L7 13"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

DownloadIcon.propTypes = {
  sx: PropTypes.object
}
